import { render } from "./details.vue?vue&type=template&id=1a3dc383&scoped=true"
import script from "./details.vue?vue&type=script&lang=js"
export * from "./details.vue?vue&type=script&lang=js"

import "./details.vue?vue&type=style&index=0&id=1a3dc383&lang=css"
import "./details.vue?vue&type=style&index=1&id=1a3dc383&lang=scss&scoped=true"

import exportComponent from "/Users/huangli/Desktop/未命名文件夹 2/borun/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a3dc383"]])

export default __exports__